// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1664824317654
      var cssReload = require("/home/kjb/DIR/projects/wordle/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  